import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=3f736ae2&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"
import style0 from "./index1.vue?vue&type=style&index=0&id=3f736ae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f736ae2",
  null
  
)

export default component.exports